/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_HelpInputs */

const en_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the source type for your media import`)
};

const fr_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez le type de source pour l'importation de votre media`)
};

const de_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie den Quelltyp für Ihren Medienimport aus.`)
};

const it_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il tipo di origine per l'importazione dei tuoi contenuti multimediali`)
};

const ru_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите тип источника для импорта медиафайлов.`)
};

const es_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione el tipo de fuente para su importación de medios`)
};

const zh_cn2_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择媒体导入的源类型`)
};

const ja_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアインポートのソースタイプを選択します`)
};

const hi_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने मीडिया आयात के लिए स्रोत प्रकार का चयन करें`)
};

const pt_pt2_media_import_source_help = /** @type {(inputs: Media_Import_Source_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o tipo de origem para a sua importação de mídia.`)
};

/**
* | output |
* | --- |
* | "Select the source type for your media import" |
*
* @param {Media_Import_Source_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_help = /** @type {((inputs?: Media_Import_Source_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_help(inputs)
	if (locale === "de") return de_media_import_source_help(inputs)
	if (locale === "it") return it_media_import_source_help(inputs)
	if (locale === "ru") return ru_media_import_source_help(inputs)
	if (locale === "es") return es_media_import_source_help(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_help(inputs)
	if (locale === "ja") return ja_media_import_source_help(inputs)
	if (locale === "hi") return hi_media_import_source_help(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_help(inputs)
	return en_media_import_source_help(inputs)
});